import {
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material';
import React from 'react';
import discount from 'configs/discount_survey_service.json';
import lodash from 'lodash';

const DiscountSurveyService: React.FC = () => {
    const discountKeys = Object.keys(discount);
    return (
        <Box>
            <TableContainer
                component={Paper}
                sx={{
                    boxShadow: 'none',
                    border: 'none',
                }}
            >
                <Table sx={{ borderCollapse: 'collapse' }}>
                    <TableHead
                        sx={{
                            backgroundColor: 'var(--color-primary-lighter)',
                        }}
                    >
                        {['STT', 'Số lượng mẫu', 'Tỷ lệ chiết khấu'].map(
                            (item, index) => (
                                <TableCell
                                    key={`header-${index}`}
                                    align={'left'}
                                    sx={{
                                        border: 'none',
                                        fontWeight: 600,
                                        fontSize: '18px',
                                        lineHeight: '21.78px',
                                    }}
                                >
                                    {item}
                                </TableCell>
                            )
                        )}
                    </TableHead>
                    <TableBody>
                        {discountKeys.map((item, index) => {
                            const discountCondition = lodash.get(
                                discount,
                                `${item}.condition_count_response`,
                                {
                                    text: '',
                                }
                            );
                            const discountValue = lodash.get(
                                discount,
                                `${item}.discount`,
                                {
                                    text: '',
                                }
                            );
                            return (
                                <TableRow key={`row-${index}`}>
                                    <TableCell
                                        sx={{
                                            border: 'none',
                                            fontWeight: 600,
                                            fontSize: '18px',
                                            lineHeight: '21.78px',
                                        }}
                                    >
                                        {item}
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            border: 'none',
                                            fontWeight: 600,
                                            fontSize: '18px',
                                            lineHeight: '21.78px',
                                        }}
                                    >
                                        {discountCondition.text}
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            border: 'none',
                                            fontSize: '18px',
                                            lineHeight: '21.78px',
                                        }}
                                    >
                                        {discountValue.text}
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default DiscountSurveyService;
